import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./inbox.css";
import { showGlobalMessage } from "../../../services/globalMessage";


const API_BASE = "https://api.chbtkd.ir";


const Inbox = ({ role }) => {


  const navigate = useNavigate();


  const [messages, setMessages] = useState([]);

  const [selected, setSelected] = useState([]);



  useEffect(() => {


      const loadMessages = () => {


        const currentRole =
          localStorage.getItem("user_role") || role;


        const token =
          localStorage.getItem(
            `${currentRole}_token`
          );



        fetch(
          `${API_BASE}/api/notifications/inbox/`,
          {
            headers:{
              Authorization:
              `Bearer ${token}`
            }
          }
        )

        .then(res=>res.json())

        .then(data=>{


            console.log(
                "NOTIFICATION DATA:",
                data
            );


            setMessages(data);


        });


      };



      // بارگذاری اولیه
      loadMessages();



      // گوش دادن به تغییر وضعیت پیام
      window.addEventListener(
        "messagesUpdated",
        loadMessages
      );



      return () => {

        window.removeEventListener(
          "messagesUpdated",
          loadMessages
        );

      };


  },[role]);






  const getToken = () => {


    const currentRole =
      localStorage.getItem("user_role") || role;


    return localStorage.getItem(
      `${currentRole}_token`
    );


  };







  const toggleSelect=(id)=>{


    setSelected(prev =>

      prev.includes(id)

      ?

      prev.filter(
        item=>item!==id
      )

      :

      [
        ...prev,
        id
      ]

    );


  };







  const openMessage=(id)=>{


      setMessages(prev =>

        prev.map(item =>

          item.id === id

          ?

          {
            ...item,
            is_read:true,
            has_new_reply:false
          }

          :

          item

        )

      );


      navigate(
        `/dashboard/${role}?section=message-detail&id=${id}`
      );


  };









  const markSelectedRead = async()=>{


    if(!selected.length)
      return;



    const token=getToken();



    const res =
      await fetch(

        `${API_BASE}/api/notifications/messages/bulk-read/`,

        {
          method:"POST",

          headers:{
            "Content-Type":"application/json",

            Authorization:
            `Bearer ${token}`
          },

          body:JSON.stringify({
            ids:selected
          })

        }

      );



    if(res.ok){


      setMessages(prev =>

        prev.map(item=>

          selected.includes(item.id)

          ?

          {
            ...item,
            is_read:true
          }

          :

          item

        )

      );


      setSelected([]);


    }



  };









  const deleteSelected = async()=>{


    if(!selected.length)
      return;



    const token=getToken();



    const res =
      await fetch(

        `${API_BASE}/api/notifications/messages/bulk-delete/`,

        {
          method:"POST",

          headers:{
            "Content-Type":"application/json",

            Authorization:
            `Bearer ${token}`
          },


          body:JSON.stringify({
            ids:selected
          })


        }

      );



    if(res.ok){


      setMessages(prev =>

        prev.filter(
          item =>
          !selected.includes(item.id)
        )

      );


      setSelected([]);


    }


  };








  const confirmAction=(text,action)=>{


    showGlobalMessage({

      type:"confirm",

      title:"تأیید عملیات",

      message:text,

      onConfirm:action,

      onCancel:()=>{}

    });


  };








  const unreadCount =

    messages.filter(
      item=>!item.is_read
    ).length;








return (

<div
className="inbox-container"
dir="rtl"
>



<div className="inbox-header">


<div>

<h1>
📩 صندوق پیام‌ها
</h1>


<p>
مدیریت پیام‌های دریافتی
</p>

</div>



<div className="inbox-counter">

<span>
{messages.length}
</span>

پیام


<br/>


<span className="unread-count">
{unreadCount}
</span>

خوانده نشده


</div>


</div>







<div className="inbox-actions">


<button

className="read-btn"

onClick={()=>

confirmAction(

`آیا از علامت‌گذاری ${selected.length} پیام مطمئن هستید؟`,

markSelectedRead

)

}

>

✓ خوانده شده

</button>





<button

className="delete-btn"

onClick={()=>

confirmAction(

`آیا از حذف ${selected.length} پیام مطمئن هستید؟`,

deleteSelected

)

}

>

🗑 حذف

</button>



</div>








<div className="message-list">


{

messages.length===0


?

<div className="empty-message">

📭 پیامی وجود ندارد

</div>



:


messages.map(item=>(


<div

key={item.id}

className={

item.is_read

?

"message-card"

:

"message-card unread"

}

>




<div className="message-select">


<input

type="checkbox"

checked={
selected.includes(item.id)
}

onChange={()=>toggleSelect(item.id)}

/>


</div>







<div

className="message-main"

onClick={()=>openMessage(item.id)}

>


<div className="message-top">


<h3>

{item.title}

</h3>




{

!item.is_read &&

<span>

جدید

</span>

}



{

item.has_new_reply &&

<span className="reply-new-badge">

پاسخ جدید

</span>

}



</div>







<p>

{
item.body.length > 120

?

item.body.substring(0,120)+"..."

:

item.body

}

</p>




<div className="message-meta">


📅

{

new Date(
item.created_at
)

.toLocaleDateString(
"fa-IR"
)

}



</div>


</div>






<div className="message-arrow">

مشاهده ←

</div>





</div>


))

}


</div>





</div>

);


};


export default Inbox;